var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"incellderm-sns--go mt-4"},[_c('a',{attrs:{"href":"https://www.instagram.com/incellderm.official","target":"_blank"}},[_c('img',{staticClass:"incellderm-sns--insta",attrs:{"src":require("@/assets/images/common/ico_instar_on.svg"),"alt":"인스타그램"}})])])
}]

export { render, staticRenderFns }